"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerApi = exports.booksApi = void 0;
var request_1 = __importDefault(require("@/utils/request"));
// 书籍管理
exports.booksApi = {
    getBooksList: function (params) {
        if (params === void 0) { params = {}; }
        return (0, request_1.default)({
            url: "/book/books-list",
            method: "get",
            params: params,
        });
    },
    addBook: function (data) {
        return (0, request_1.default)({
            url: "/book/books/create",
            method: "post",
            data: data
        });
    },
    getBookInfo: function (id) {
        return (0, request_1.default)({
            url: "/book/books/".concat(id),
            method: "get",
        });
    },
    putBookInfo: function (data, id) {
        return (0, request_1.default)({
            url: "/book/books/".concat(id),
            method: "put",
            data: data
        });
    },
    deleteBookInfo: function (id) {
        return (0, request_1.default)({
            url: "/book/books/".concat(id),
            method: "delete",
        });
    },
};
// 借书管理
exports.borrowerApi = {
    getBorrowerList: function (params) {
        if (params === void 0) { params = {}; }
        return (0, request_1.default)({
            url: "/book/borrower-list",
            method: "get",
            params: params,
        });
    },
    getBorrowerInfo: function (id) {
        return (0, request_1.default)({
            url: "/book/borrower/".concat(id),
            method: "get",
        });
    },
    putBorrowerInfo: function (data, id) {
        return (0, request_1.default)({
            url: "/book/borrower/".concat(id),
            method: "put",
            data: data
        });
    },
    deleteBorrowerInfo: function (id) {
        return (0, request_1.default)({
            url: "/book/borrower/".concat(id),
            method: "delete",
        });
    },
    addBorrower: function (data) {
        return (0, request_1.default)({
            url: "/book/borrower/create",
            method: "post",
            data: data
        });
    },
};
